import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const RETURN_TO_KEY = "returnTo";
const PUBLIC_PATHS = ["/login", "/licenseKey", "/resetPassword"];

export default function Gate({ children }) {
    
    const isLoggedIn = useSelector((s) => s.auth.isLoggedIn);
    const location = useLocation();

    const isPublic = PUBLIC_PATHS.some((p) =>
        location.pathname.startsWith(p)
    );

    // 로그인되어 있으면 통과
    if (isLoggedIn) return <>{children}</>;

    // 공개 경로면 통과
    if (isPublic) return <>{children}</>;

    // 미로그인 상태라면 현재 주소를 저장 후 /login으로 이동
    const returnTo =
        (location.pathname || "/") +
        (location.search || "") +
        (location.hash || "");

    sessionStorage.setItem(RETURN_TO_KEY, returnTo);
    return <Navigate to="/login" replace state={{ returnTo }} />;
}